<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.drug', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <b-container>
                        <div class="list-group list-group-flush">

                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.tradeName') }}:

                                        <span class="font-weight-bold">
                                            {{  getValue('nom_commercial') }}
                                        </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.activeSubstance') }}:

                                        <span class="font-weight-bold">
                                            {{  getValue('principe_actif') }}
                                        </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.therapeuticClass') }}:

                                        <span class="font-weight-bold">
                                            {{  getValue('classe_medicamenteuse') }}
                                        </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.dosage') }}:

                                        <span class="font-weight-bold">
                                            {{  getValue('forme_et_dosage') }}
                                        </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.packaging') }}:

                                        <span class="font-weight-bold">
                                            {{  getValue('conditionement') }}
                                        </span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updateDrug">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.drug', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mDrug.nom_commercial }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteDrug">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';

    export default {
        name: "Drug",

        computed: {
            ...mapGetters(["drug",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole',]),

            can:function(){
                if (this.hasAdminRole || this.hasGestionnaireRole ){
                    return true;
                }else if ( this.hasPraticienRole ){
                    if (!_.isUndefined(this.form)){
                        return  this.form.isAuthor
                    }
                    return false;
                }
                return false;
            },

            mDrug: function() {
                return this.drug;
            },
        },

        data(){
            return {
                drug_id: this.$route.params.drug,

            }
        },

        methods: {
            medicament() {
                let args = {
                    medicament: this.drug_id
                };

                this.$store.dispatch("getDrug", {args});
            },

            updateDrug() {
                this.$router.push({ name: 'edit-drug', params: { drug: this.drug_id } });
            },

            deleteDrug() {
                let self = this;
                let args = {
                    medicament: this.drug_id
                };

                let successMessage = this.$i18n.t('message.drugDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteDrug', { args, index: self.drug_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                });
            },

            getValue(item){

                if (!_.isUndefined(this.mDrug)){
                    if (this.mDrug.hasOwnProperty(item)){
                        return this.mDrug[item];
                    }else{
                        return "";
                    }
                }
                return "";
            },
        },

        mounted() {
            this.medicament();
        }
    }
</script>

<style scoped>

</style>